import React, {ReactElement} from 'react';

import {useMailFeedback} from 'ui/effects/useMailFeedback';
import {useUIStore} from 'store/UI';
import {NewTabLink} from 'components/NewTabLink';
import {AppVersion} from 'components/AppVersion';
import {Mention} from 'components/Mention';
import {Button} from 'components/Button';
import {Text} from 'components/Text';

import {Wrapper, Action, Section, About, Authors, ErrorAction} from './style';
import Designer from 'assets/static/designer.webp';
import Developer from 'assets/static/developer.webp';

export const Credits = (): ReactElement => {
  const feedbackCallback = useMailFeedback();
  const {keyboardVisible} = useUIStore();

  return (
    <Wrapper className={keyboardVisible && 'hidden'}>
      <Section>
        <About>
          <Text>
            <strong>Тяжеловато</strong> подсказывает бюджет на день и мешает потратить лишнего.
          </Text>
          <AppVersion />
        </About>

        <Authors>
          <Mention link='https://t.me/superufastar' name='Костя' role='Дизайн' photo={Designer} />
          <Mention link='https://bespoyasov.ru' name='Саша' role='Разработка' photo={Developer} />
        </Authors>
      </Section>

      <Action>
        <NewTabLink href='https://boosty.to/unlimitedpie'>Наши продукты о доходах в IT</NewTabLink>
      </Action>

      <Action>
        <NewTabLink href='https://t.me/tzlvt'>Почитать про идеи и планы</NewTabLink>
      </Action>

      <ErrorAction>
        <Button onPress={feedbackCallback} inline>
          Сообщить об ошибке
        </Button>
      </ErrorAction>
    </Wrapper>
  );
};
